import { mermaidPropsSchema } from '../component-catalog.js';
export const mermaidDefinition = {
    type: 'Mermaid',
    category: 'content',
    propsSchema: mermaidPropsSchema,
    isDataBacked: false,
    needsMeasuredDims: true,
    defaultMinHeight: 200,
    description: 'Mermaid diagram from raw source. Props: code (required), mermaidStyle? (color overrides).',
};
//# sourceMappingURL=Mermaid.js.map